import React from "react";
import { Search } from "lucide-react";
import styles from "./PeopleSearchSearchBar.module.scss";

type PeopleSearchSearchBarProps = {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  disabled?: boolean;
  size?: "default" | "large";
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
};

const PeopleSearchSearchBar: React.FC<PeopleSearchSearchBarProps> = ({
  value,
  onChange,
  placeholder = "Buscar por nombre o empresa…",
  disabled = false,
  size = "default",
  onKeyDown,
}) => {
  return (
    <div className={`${styles.root} ${size === "large" ? styles.root_large : ""}`.trim()}>
      <Search className={styles.icon} size={20} aria-hidden />
      <input
        type="search"
        className={styles.input}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={onKeyDown}
        placeholder={placeholder}
        disabled={disabled}
        aria-label="Buscar por nombre o empresa"
        autoComplete="off"
      />
    </div>
  );
};

export default PeopleSearchSearchBar;
